// extracted by mini-css-extract-plugin
export default {"addToCartControl":"T1-z","giftCard":"U1-z","btnContainer":"V1-z","cartButton":"W1-z","disabled":"X1-z"};